import React, { useEffect, useState } from 'react'
import firebase from 'firebase/app';
import 'firebase/storage'

import DefaultImage from '../../../../../assets/ic_default_image.jpg'

const Image = ({
    imagePath,
    size,
    className,
    withHeight,
}) => {
    const [imageSrc, setImageSrc] = useState()

    useEffect(() => {
        if (imagePath) {
            firebase.storage().refFromURL(imagePath).getDownloadURL()
                .then((url) => {
                    setImageSrc(url)
                })
        }
        else {
            setImageSrc(DefaultImage)
        }
    }, [imagePath])

    return (
        <img
            className={className}
            src={imageSrc}
            width={size}
            alt=''
            style={{
                maxWidth: '500px'
            }} />
    )
}

export default Image
